
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"9","height":"14","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#FFF","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M7.69 14c-.337 0-.673-.129-.93-.388L1.22 8.011a1.308 1.308 0 1 1 1.86-1.842l5.541 5.602A1.308 1.308 0 0 1 7.691 14"}}),_c('path',{attrs:{"d":"M2.15 8.399a1.31 1.31 0 0 1-.926-2.235l5.54-5.54a1.31 1.31 0 0 1 1.852 1.852l-5.54 5.54a1.31 1.31 0 0 1-.925.383"}})])])
          )
        }
      }
    